<template>
  <div class="home-container">
    <div class="linear-bg">
      <img src="img/home/home-head-bg.png">
    </div>
    <div class="home-scroll">
      <div class="home-top-bar"><span>{{ this.$store.getters.getBaseInfo.name }}</span></div>
      <div class="banner">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v,key) in banners" :key="key">
            <van-image class="banner_img" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular"/>
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>
      <div class="hot-game">
        <div class="hot-title-div">
          <div><span>{{ $t("一夜情活动") }}</span></div>
          <div></div>
        </div>
        <div class="hot-items-div">
          <div class="van-grid">
            <div class="van-grid-item" style="flex-basis: 25%;" v-for="itme in gameitem" :key="itme.id"  @click="toLottery(itme.key,itme.id)">
              <div class="van-grid-item__content van-grid-item__content--center">
                <div class="game_item_img van-image">
                  <img class="van-image__img" :src="itme.ico">
                </div>
                <span>{{ itme.name }}</span></div>
            </div>

          </div>
        </div>
      </div>
      <div class="van-pull-refresh">
        <div class="van-pull-refresh__track" style="transition-duration: 300ms;">
          <div class="van-pull-refresh__head"></div>
          <div class="hot-recommend">
            <div class="hot-title-div">
              <div><span>{{$t("home.popularity")}}</span></div>
              <div @click="video()"><span>{{$t("home.more")}}</span><i class="van-icon van-icon-arrow" style="color: rgb(232, 121, 249);"></i>
              </div>
            </div>
            <div class="movie_list_1">
              <div class="movie-list-item" v-for="(v,key) in videolist" :key="key" @click="toPlayVideo(v.id)">
                <img alt="" class="cover_img" :src="v.vod_pic" lazy="loaded">
                <div class="movie-list-item-bottom"> {{ v.vod_name }}</div>
              </div>


            </div>
            <div class="hot-title-div">
              <div><span>{{ $t("人气推荐") }}</span></div>
              <div @click="video()">
                <span>{{$t("home.more")}}</span>
                <i class="van-icon van-icon-arrow" style="color: rgb(232, 121, 249); font-size: 25px;"></i>
              </div>
            </div>
            <div class="movie_list_1">
              <div class="movie-list-item" v-for="(v,key) in video_list" :key="key" @click="toPlayVideo(v.id)">
                <img alt="" class="cover_img" :src="v.vod_pic" lazy="loaded">
                <div class="movie-list-item-bottom"> {{ v.vod_name }}</div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div></div>
</template>

<script>
export default {
  data() {
    return {
      videolist: {},
      video_list: {},
      notice: this.$t("msg.获取中"),
      mailType: false,
      i: 0,
      activeName: "",
      mailText: {
        name: "",
        text: ""
      },
      mail: "",
      active: 1,
      banners: [{}],
      basicData: [],
      gameitem: [{}, {}, {}, {}],
      consort: [{}, {}, {}, {}],
      yuyueList: [{}, {}, {}, {}, {}, {}, {}, {}],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        effect: "coverflow",
        autoplay: !0
      },
      intervalId: ""
    };
  },
  methods: {
    MineFun() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Mine'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    toMail() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Mail'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    getyuyueList: function () {
      var t = this;
      clearInterval(t.intervalId);
      t.active = 2;
      this.$http({
        method: "get",
        url: "sys_yuyue_number"
      }).then((function (e) {
            t.yuyueList = e.data
            t.activeName = t.$t("text.txt12").replace("0", Math.floor(Math.random() * 2000) + 1000);
            for (var i = 0; i < t.yuyueList.length; i++) {
              t.yuyueList[i] = t.$t("text.txt13").replace("44", t.yuyueList[i]);
            }
            t.i = 0;
            t.intervalId = setInterval(function () {
              if (t.i >= t.yuyueList.length * 48) {
                t.i = 0;
              }
              t.i = t.i + 1;

            }, 30);
          }
      ))
    },
    gotoMenu(router) {
      this.$router.replace(router)
    },

    profile(id) {
      this.$router.push({path: '/profile?id=' + id});
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/Lottery?key=' + key + "&id=" + id})
      }

    },
    video(){
      this.$router.push({path:'/Video'})
    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/PlayVideo?id=' + id})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast(this.$t("msg.刷新成功！"));
      }, 500);
    },

    getMail() {
      this.$http({
        method: 'get',
        url: 'get_mail'
      }).then(res => {
        if (res.data) {
          this.mailText = res.data;
          this.mailType = true;
        }
      })

    },

    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.basicData = res.data;
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        this.getGameItem();//获取首页游戏列表
        console.log(res.data);
        this.videolist = this.basicData.video;
        this.video_list = this.basicData.video_list;
      })

    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_hot'
      }).then(res => {
        this.gameitem = res.data
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          this.mail = res.data.mail;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path: '/Login'})
          }
        } else if (res.code === 401) {
          //this.$toast(res.msg);
        }
      })
    },
    getBanner(data) {
      this.banners = data.banners;
    }
  },
  mounted() {

  },
  created() {

    if (localStorage.getItem('token')) {
      this.getBasicConfig();
      this.getUserInfo();
      //this.getMail();
    } else {
      this.$router.push({path: '/Login'})
    }

  }
}

</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.banner_swiper {
  height: 100%;
  width: 100%;
}
</style>
